import { CatalystInsightType } from '@toggle/toggle';
import React from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

import { CatalystInsightTooltip } from '../catalyst-insight-tooltip/CatalystInsightTooltip';
import { CatalystDrawerParams, useCatalystDrawer } from '../useCatalystDrawer';
import * as S from './CatalystInsightIcon.styles';
import { getCatalystInsightIconProps } from './utils';

export interface CatalystInsightIconProps {
  catalystInsightId: string;
  size?: number;
  enableHover?: boolean;
  isBordered?: boolean;
  identifier?: string;
  type: CatalystInsightType;
  customSize?: { width: number; height: number };
  isDisabled?: boolean;
}

export const CatalystInsightIcon = ({
  catalystInsightId,
  size,
  enableHover = true,
  isBordered = true,
  type,
  identifier,
  customSize,
  isDisabled,
}: CatalystInsightIconProps) => {
  const { openDrawer } = useCatalystDrawer();
  const iconProps = getCatalystInsightIconProps({ isBordered, isDisabled });
  return (
    <TooltipContainer
      label={
        <CatalystInsightTooltip
          insightId={catalystInsightId}
          category={type}
          iconProps={iconProps}
        />
      }
      placement="top-start"
      offsetY={-5}
      offsetX={8}
      hasMaxWidth={false}
      disabled={!enableHover || isDisabled}
      inPortal
      withSafePolygon
    >
      <S.StyledIcon
        {...iconProps}
        {...(customSize
          ? { width: customSize.width, height: customSize.height }
          : { size })}
        $isDisabled={isDisabled}
        $enableHover={enableHover}
        onClick={e => {
          e.stopPropagation();

          if (!identifier || !type) {
            return;
          }

          const drawerParams: CatalystDrawerParams =
            type === 'company'
              ? { type, entityTag: identifier, insightId: catalystInsightId }
              : { type, themeId: identifier, insightId: catalystInsightId };

          openDrawer(drawerParams);
        }}
      />
    </TooltipContainer>
  );
};
